import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CleverTapConstents } from 'src/app/services/constants';
import { TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-application-letter',
  templateUrl: './application-letter.component.html',
  styleUrls: ['./application-letter.component.scss']
})
export class ApplicationLetterComponent implements OnInit {
  signerDetails: any = [];
  url: string = '';
  get userSelected() {
    return this.signerDetails.find((u: any) => u.selected === true);
  }
  get urlS() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  get isAllSigned() {
    return this.signerDetails.every((signer: any) => signer.signed);
  }
  constructor(public util: UtilService, private sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    this.util.updateESigned().then(() => {
      this.signerDetails = this.util.loanDetails.eSignStatusModel.signerDetails;
      const user = this.signerDetails.find((u: any) => !u.signed);
      if (user) {
        user.selected = true;
      }
    });
    console.log(this.util.loanDetails)
  }

  unSelectUsers(index: number) {
    this.signerDetails = this.signerDetails.map((user: any) => {
      return { ...user, selected: false };
    });
    this.signerDetails[index].selected = true;
  }

  professingFeePopup: boolean = false;

  showFeeDialog() {
    this.professingFeePopup = true;
  }

  eSigned() {
    try{
      const user = this.userSelected;
      if (this.isAllSigned) {
        this.util.getProducts().then(()=>this.util.navigationHandler());
        return;
      }
      if (!user.signed) {
        this.util.cleverTapEventCall(CleverTapConstents.application_form_Esign_initiated,{
          'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
        });
        const signerDetail = this.util.loanDetails.eSignResponse.signer_info.find((sign: any) => sign.signer_ref_id == user.signerRefId,);
        this.url = signerDetail.invitation_link;
      } else {
        this.url = '';
      }
    }catch(err:any){
      this.util.showToaster('Please Contact your RM, Not able to find signer info!!', TosterMsgType.ERROR, 3000);
      
    }
    
  }

  onEsigned(isUserSigned: boolean) {
    this.url = '';
    if (isUserSigned) {

      this.util.getProducts().then(() => {
        this.util.updateESigned().then(() => {
          this.signerDetails = this.util.loanDetails.eSignStatusModel.signerDetails;
          const user = this.signerDetails.find((u: any) => !u.signed);
          if (user) {
            user.selected = true;
          }
          if (this.isAllSigned) {
            this.util.navigationHandler();
            return;
          }
        });
      });
    }
  }
}
